import favoriteFilled from "@iconify/icons-mdi/heart";
import favoriteBorder from "@iconify/icons-mdi/heart-outline";
import { Icon } from "@iconify/react";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Grid,
  IconButton,
  Rating,
  SwipeableDrawer,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import axios from "axios";
import debounce from "lodash/debounce";
import { useSnackbar } from "notistack";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { isProductLiked, likeProduct, unlikeProduct } from "../../store/reducers/userReducer";
import { useLikedProducts } from "../contexts/LikedProductsContext.js";
import { useRecentSearches } from "../contexts/RecentSearchesContext.js";
import NearbyStoresMobile from "../products/nearbyStores/products.nearbyStoresMobile.jsx";
import OnlineStoresMobile from "../products/onlineStores/products.onlineStoresMobile.jsx";
import ProductCard from "./ProductCard.jsx";
import ChatMobile from "./Products.chatMobile";
import DetailsLarge from "./Products.detailsLarge";
import Error from "./Products.error.jsx";
import FloatingChatButton from "./Products.floatingbutton";
import ProductSkeleton from "./skeletons/Products.skeleton.Details.jsx";
import SearchSkeleton from "./skeletons/Products.skeleton.Searching.jsx";
// const ProductCard = React.lazy(() => import("./ProductCard.jsx"));
// const DetailsLarge = React.lazy(() => import("./products.DetailsLarge.jsx"));
// const Error = React.lazy(() => import("./Products.error.jsx"));

const Details = () => {
  const navigate = useNavigate();
  const { addSearch } = useRecentSearches();
  const { addLikedProduct, removeLikedProduct } =
        useLikedProducts();
  const { id } = useParams();
  const [product, setProduct] = useState({
    name: "",
    img: "",
    rating: "",
    description: "",
    nutrition: "",
    ingredients: "",
    image: "",
    onlineStores: [],
    upc: "",
    classifications: [],
    found: false,
  });
  const [bottom, setBottom] = useState(false);
  const [similarProducts, setSimilarProducts] = useState({
    similarProducts: [],
    isfound: false,
  });
  const snackbar = useSnackbar();
  const [showMore, setShowMore] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState(false);
  const [nearbyStoresOpen, setNearbyStoresOpen] = useState(false);
  const [isBottomButtonVisible, setIsBottomButtonVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openIngredients, setOpenIngredients] = useState(false);
  const [additonalProductsError, setAdditonalProductsError] = useState(false);
  const [talkToProductOpen, setTalkToProductOpen] = useState(false);
  const [zipcode, setZipcode] = useState(""); // Stores ZIP code input
  const [locationDenied, setLocationDenied] = useState(false); // Flag for geolocation failure

  

  // const [liked, setLiked] = useState(false);
  const [product_id, setproduct_id] = useState("");
  const [upcSearched, setupcSearched] = useState(null);
  const bottomButtonRef = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const handleScroll = useCallback(
    debounce(() => {
      const scrollPosition = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const bodyHeight = document.body.offsetHeight;
      const bottomThreshold = 100; // Adjust this value as needed

      setIsBottomButtonVisible(
        scrollPosition + windowHeight >= bodyHeight - bottomThreshold
      );
    }, 100),
    []
  );
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    // If openChat=true is in the URL, open the drawer
    if (searchParams.get("openChat") === "true") {
      setTalkToProductOpen(true);
    }
  }, [searchParams]);
  // const getDesciption = useCallback(async (name) => {
  //   try {
  //     console.log("fetching product description: ", name);
  //     const { data } = await axios.post("/get_product_description", {
  //       name: name,
  //     });
  //     console.log("description data: ", data);
  //     return data;
  //   } catch (error) {
  //     console.log("error fetching product description: ", error);
  //     return "";
  //   }
  // });

  const isUPC = () => {
    const regex = /^[0-9]+$/;
    return regex.test(id);
  };
  // /search/openai
  // /get_product_info
  const fetchData = useCallback(
    debounce(async (id) => {
      let backend = "";
      const isUpc = isUPC(id);
      setupcSearched(isUpc); // Update state immediately
      backend = isUpc ? "/dynamo_getByUPC" : "/get_product_info";
      /*isUPC(id)
        ? (backend = "/dynamo_getByUPC")
        : (backend = "/get_product_info");*/
      try {
        console.log("is upc", isUPC(id));
        setSimilarProducts({ similarProducts: [], isfound: false });
        const response = await axios.post(backend, { upc: id, barcode: id });
        console.log(response);
        console.log(response.data.message);
        if (response.status === 200 && response.data.message === "Product not found") {
          console.log("status code 200");
          console.log(response.data);
          navigate("/products/search", { state: { products: [] } });
        }
        if (response.status === 201) {
          console.log("status code 203");
          console.log("navigate: ", response.data);
          navigate("/products/search", { state: { products: response.data } });
        }
        console.log("test_responses: ", response.data.item_attributes);
        const newProduct = {
          name: response.data?.Name,
          rating: 4.5,
          company: response.data?.Company,
          data_from: response.data?.Data_from,
          weight: response.data?.Weight,
          description: response.data?.Description,
          ingredients: response.data?.Ingredients,
          nutrition: response.data?.Nutrition,
          image: response.data?.Image,
          onlineStores: response?.data?.Online_Stores,
          upc: response.data?.UPC,
          // classifications: ["test", "test"],
          Classifications: response?.data?.Classifications
            ? response?.data?.Classifications
            : [],
          found: true,
        };

        setProduct(newProduct);
        if (newProduct.name) {
          addSearch(newProduct);
          console.log("making additional products request");
          axios
            .post("/get_additional_products", {
              product:
                newProduct.name.split(" ").length > 4
                  ? newProduct.name.split(" ").slice(0, 3).join(" ")
                  : newProduct.name.split(" ")[0],
                UPC: newProduct.upc,
            })
            .then((response) => {
              console.log("API Response:", response);
          
              setLoading(false);
              console.log(response.data.products)
              console.log(response.data.message)
              if (response.data.message === "No products found") {
                  console.log("No similar products found.");
                  setSimilarProducts({ similarProducts: [], isfound: false });
              } else {
                  let products = response.data.products.map((product) => ({
                      title: product.Name,
                      image: product.Image,
                      id: product.UPC,
                  }));
                  setSimilarProducts({ similarProducts: products, isfound: true });
                  console.log(similarProducts)
              }
          })
          
            .catch((error) => {
              switch (error.response.status) {
                case 404:
                  console.log("Product not found in database");
                  setAdditonalProductsError(true);
                  break;
                
                case 500:
                    console.log("Product not found in database");
                    setAdditonalProductsError(true);
                    break;
                default:
                  setAdditonalProductsError(true);
                  console.log("An unexpected error happend");
                  break;
              }
            });
        }
      } catch (error) {
        console.log(error);
        setError(true);
      }
    }, 300),
    [id]
  );

  useEffect(() => {
    fetchData(id);
  }, [id]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsBottomButtonVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (bottomButtonRef.current) {
      observer.observe(bottomButtonRef.current);
    }

    return () => {
      if (bottomButtonRef.current) {
        observer.unobserve(bottomButtonRef.current);
      }
    };
  }, []);
  const isLiked = useSelector((state) => isProductLiked(state.user.user, id));
  // useEffect(() => {
  //   if (product.found && product.upc) {
  //     setLiked(isProductLiked(product.upc));
  //   }
  // }, [product.found, product.upc, isProductLiked]);
  const handleLikeClicked = (e) => {
        e.stopPropagation();
        const skeletonProduct = {
          title: product.name,
          image: product.image,
          upc: product.upc
        };        
        if (!user || !user.token) {
          snackbar.enqueueSnackbar("Please log in to like products!", {
            variant: "error",
            autoHideDuration: 2000,
          });
          return;
        }

        if (isLiked) {
          dispatch(unlikeProduct({product: skeletonProduct}));
          removeLikedProduct(product.upc);
  
        } else {
          dispatch(likeProduct({product: skeletonProduct}));
          addLikedProduct(product);

        }
  };
  const handleOpenNearbyStores = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setNearbyStoresOpen(true); // Location available, open drawer
        },
        (error) => {
          setLocationDenied(true); // If location fails, show ZIP input in the drawer
          setNearbyStoresOpen(true);
        }
      );
    } else {
      setLocationDenied(true); // If geolocation not supported, show ZIP input in drawer
      setNearbyStoresOpen(true);
    }
  };

  const handleZipSubmit = () => {
    if (zipcode.trim() !== "") {
      setLocationDenied(false); // Hide ZIP input
    }
  };
  // Hardcoded similar products - make sure to change later
  // const similarProducts = [
  //   { title: "Classic Lemonade", image: yellow, id: 1 },
  //   { title: "Zero Sugar Fruit Punch", image: purple, id: 2 },
  //   { title: "Strawberry Peach", image: pink, id: 3 },
  //   { title: "Strawberry Peach", image: lighty, id: 4 },

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function removeLeadingZeros(upc) {
    return upc.replace(/^0+/, '');
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (windowWidth >= 768) {
    if (product && !error) {
      return (
        <DetailsLarge
          id={id}
          product={product}
          similarProducts={similarProducts}
          additionalProducts={additonalProductsError}
          isupc={isUPC(id)}
        />
      );
    }
    else if(error) {
      return <Error />
    }
  }

  if (error) {
    return <Error />;
  }

  return (
    <>
      <Container
        disableGutters
        maxWidth={false}
        sx={{
          backgroundColor: "white",
          minHeight: "100vh",
          pb: 0,
          mb: 0,
          width: "100%",
        }}
      >
        {!(removeLeadingZeros(product.upc) === removeLeadingZeros(id))? (
           <Box>{isUPC(id) ? <ProductSkeleton /> : <SearchSkeleton />}</Box>
        ) : (
          <Box width="100%">
            <Box sx={{ backgroundColor: "white" }}>
              {/* Top Navigation */}
              <AppBar
                position="static"
                color="transparent"
                elevation={0}
                sx={{ pl: 2, pt: 1, pb: 2 }}
              >
                <Toolbar>
                  {/* <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="back"
                    onClick={() => navigate(-1)}
                  >
                    <ArrowBackIosNewIcon />
                  </IconButton> */}
                  {/* <Box>
                    <Box sx={{ cursor: "pointer" }}>
                      <Typography
                        variant="h6"
                        onClick={() => navigate("/products")}
                      >
                        Home
                      </Typography>
                    </Box>
                  </Box> */}
                </Toolbar>
              </AppBar>

              {/* Product Image */}
              <Box textAlign="center" sx={{ position: "relative" }}>
                {" "}
                {/* Set relative positioning here */}
                <img
                  src={
                    product.image
                      ? product.image
                      : `https://placehold.co/800x400?text=${product.name}`
                  }
                  alt="Product"
                  style={{
                    maxHeight: "15vh",
                    height: "15vh",
                    maxWidth: "100%",
                    borderRadius: 8,
                    position: "absolute",
                    top: "-30px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 10,
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* Product Details */}
              <Box
                sx={{
                  mt: "5vh",
                  backgroundColor: "white",
                  borderRadius: "40px 40px 0 0",
                  width: "100%",
                  padding: 3,
                  pt: 5,
                  boxShadow: "0px -5px 20px rgba(0,0,0,0.1)",
                  minHeight: "95vh",
                  position: "relative",
                }}
              >
                {/* Rating and See More text */}
                <Box
                  sx={{ display: "flex", alignItems: "center", mt: 2, flex: 1 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                    <Rating
                      value={Number(product.rating)}
                      precision={0.5}
                      readOnly
                    />
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      onClick={() => navigate(`/products/reviews/${id}`)}
                      sx={{
                        ml: 1,
                        underline: "hover",
                        color: "#15224F",
                        cursor: "pointer",
                      }}
                    >
                      {product.rating} {/* can add later if we want to */}
                      {/* <span style={{ color: "#15224F" }}>(See More)</span> */}
                    </Typography>
                  </Box>

                  {/* Icon buttons */}
                  <Box sx={{ display: "flex", pr: 1 }}>
                    <IconButton
                      onClick={(e) => handleLikeClicked(e)}
                      sx={{ zIndex: 1000, width: "40px" }}
                      disabled={!product.found}
                    >
                      {product.found && (
                        <Box>
                          {isLiked ? (
                            <Icon
                              icon={favoriteFilled}
                              fontSize="large"
                              style={{ color: "#EF4F26", scale: "1.5" }}
                            />
                          ) : (
                            <Icon
                              icon={favoriteBorder}
                              fontSize="large"
                              style={{ color: "#99B2C3", scale: "1.5" }}
                            />
                          )}
                        </Box>
                      )}
                    </IconButton>
                    <IconButton
                      onClick={handleOpenNearbyStores}
                      sx={{ width: "40px" }}
                    >
                      <Icon
                        icon="tabler:map-2"
                        fontSize="large"
                        style={{ color: "#99B2C3", scale: "1.5" }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => setBottom(true)}
                      sx={{ width: "40px" }}
                    >
                      <Icon
                        icon={"material-symbols:shopping-cart-outline"}
                        fontSize="large"
                        style={{ color: "#99B2C3", scale: "1.5" }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => setAdditionalInfo(true)}
                      sx={{ width: "40px" }}
                    >
                      <Icon
                        icon={"gg:more-o"}
                        fontSize="large"
                        style={{ color: "#99B2C3", scale: "1.5" }}
                      />
                    </IconButton>
                  </Box>
                </Box>

                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    color: "#112A3B",
                    fontWeight: 500,
                  }}
                >
                  {product.name}
                </Typography>

                <Box mt={1}>
                  {product.classifications &&
                    product.classifications.map((classification, index) => (
                      <Chip
                        key={index}
                        label={classification}
                        size="small"
                        sx={{ mr: 1, mb: 0.5 }}
                      />
                    ))}
                </Box>
                <Typography
                  variant="body2"
                  mt={2}
                  color={"#15224F"}
                  fontWeight={600}
                  fontSize={16}
                  textAlign="left"
                >
                  Description
                </Typography>
                {product.description && (
                  <Box>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      paragraph
                      textAlign="left"
                      sx={{
                        display: "inline",
                        marginRight: "5px",
                      }}
                    >
                      {product.desciption}
                      {product.description.slice(
                        0,
                        showFullDescription ? undefined : 100
                      )}
                      {!showFullDescription &&
                        product.description.length > 100 &&
                        "..."}
                    </Typography>
                    {product.description.length > 100 && (
                      <Typography
                        variant="body2"
                        color="primary"
                        onClick={() =>
                          setShowFullDescription(!showFullDescription)
                        }
                        sx={{ cursor: "pointer", display: "inline" }}
                      >
                        {showFullDescription ? "Read less" : "Read more"}
                      </Typography>
                    )}
                  </Box>
                )}
                {product.ingredients && (
                  <Box>
                    <Box
                      onClick={() => setOpenIngredients((prev) => !prev)}
                      sx={{
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // Ensures icon and typography are vertically aligned
                        width: "100%",
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant="body2"
                        textAlign="left"
                        sx={{ marginTop: 0 }}
                      >
                        <b>Ingredients</b>
                      </Typography>
                      <Box
                        sx={{ ml: 1, display: "flex", alignItems: "center" }}
                      >
                        {/* Add margin to the left of the icon */}
                        {openIngredients ? (
                          <Icon icon="material-symbols:close" />
                        ) : (
                          <Icon icon="majesticons:open" />
                        )}
                      </Box>
                    </Box>
                    <Collapse in={openIngredients}>
                      <Box>{product.ingredients}</Box>
                    </Collapse>
                  </Box>
                )}

                {/* Similar Products Section */}
                <Typography
                  variant="h5"
                  color="#205375"
                  component="div"
                  sx={{ fontWeight: 600, textAlign: "left", mt: 2 }}
                >
                  Similar <span style={{ color: "#EF4F26" }}>Products</span>
                </Typography>
                {additonalProductsError ? (
                  <Box mb={3} mt={1}>
                    No similar products found.
                  </Box>
                ) : (
                  <Box>
                    {loading ? (
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        height={"20vh"}
                        textAlign="center"
                      >
                        <Typography variant="h6" gutterBottom>
                          Loading similar products...
                        </Typography>
                        <CircularProgress size={60} thickness={4.5} />
                      </Box>
                    ) : (
                      <Box>
                        <Box
                          display="flex"
                          justifyContent="left"
                          alignItems="left"
                          cursor="pointer"
                          mb={1}
                          onClick={() => setShowMore((prev) => !prev)}
                        >
                          {showMore ? (
                            <Typography variant="body2" color="textSecondary">
                              Show Less
                            </Typography>
                          ) : (
                            <Typography variant="body2" color="textSecondary">
                              Show All
                            </Typography>
                          )}
                        </Box>

                        {/* Main container for scrolling */}
                        <Box
                          sx={{
                            overflowX: "auto",
                            width: "100%",
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "nowrap",
                              width: "auto",
                              minWidth: "100%",
                            }}
                          >
                            {similarProducts?.similarProducts.length > 5 ? (
                              <Box>
                                {showMore ? (
                                  <Box>
                                    <Grid container spacing={1}>
                                      {similarProducts.similarProducts.map(
                                        (product, index) => (
                                          <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            lg={3}
                                            key={index}
                                            onClick={() => {
                                              setproduct_id(product.id);
                                              console.log(
                                                "product id: ",
                                                product_id
                                              );
                                              navigate(
                                                `/products/details/${product.id}`
                                              );
                                            }}
                                          >
                                            {" "}
                                            <ProductCard
                                              image={product.image}
                                              title={product.title}
                                              upc={product.id}
                                              height={"25vh"}
                                            />
                                          </Grid>
                                        )
                                      )}
                                    </Grid>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      flexWrap: "nowrap",
                                      overflowX: "auto",
                                    }}
                                  >
                                    {similarProducts.similarProducts
                                      .slice(0, 4)
                                      .map((product, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            flexShrink: 0,
                                            width: "17vh",
                                            marginRight: 2,
                                          }}
                                          onClick={() => {
                                            setproduct_id(product.id);
                                            console.log(
                                              "product id: ",
                                              product_id
                                            );
                                            navigate(
                                              `/products/details/${product.id}`
                                            );
                                          }}
                                        >
                                          <ProductCard
                                            image={product.image}
                                            title={product.title}
                                            upc={product.id}
                                            height={"30vh"}
                                          />
                                        </Box>
                                      ))}
                                  </Box>
                                )}
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  overflowX: "auto",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "left",
                                }}
                              >
                                {similarProducts.similarProducts
                                  .slice(0, 4)
                                  .map((product, index) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        flexShrink: 0,
                                        width: "17vh",
                                        marginRight: 2,
                                        position: "relative", // Add position relative to the parent Box
                                      }}
                                      onClick={() => {
                                        setproduct_id(product.id); // Set loading state
                                        navigate(
                                          `/products/details/${product.id}`
                                        );
                                      }}
                                    >
                                      <ProductCard
                                        image={product.image}
                                        title={product.title}
                                        upc={product.id}
                                        height={"30vh"}
                                      />
                                      {product_id === product.id && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.7)",
                                            zIndex: 1,
                                          }}
                                        >
                                          <CircularProgress />
                                        </Box>
                                      )}
                                    </Box>
                                  ))}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                )}

                {/* <Box sx={{ mt: 3 }}>
                <Button
                  onClick={() => setBottom(true)}
                  sx={{ backgroundColor: "#EF4F26" }}
                >
                  <Typography
                    variant="h5"
                    color="white"
                    component="div"
                    sx={{ fontWeight: 600, textAlign: "left" }}
                  >
                    Other Stores
                  </Typography>
                </Button>
              </Box> */}

                {/* Other Stores */}
                <SwipeableDrawer
                  anchor={"bottom"}
                  open={bottom}
                  onClose={() => setBottom(false)}
                  onOpen={() => setBottom(true)}
                >
                  <Box sx={{backgroundColor:"#E6F5FA"}}>
                  <Box
                    sx={{
                      mt: 2,
                      maxHeight: "80vh",
                      minHeight: "65vh",
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 3,
                        position: "fixed",
                        width: "90%",
                        transform: "translateY(-2vh)",
                        // backgroundColor: "white",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h5"
                          color="#205375"
                          component="div"
                          sx={{ fontWeight: 600, textAlign: "left", mb: 2 }}
                        >
                          Online <span style={{ color: "#EF4F26" }}>Stores</span>
                        </Typography>
                      </Box>
                      <Box sx={{ zIndex: 1}}>
                        <span
                          style={{
                            border: "1px solid #205375",
                            padding: "5px 10px",
                            borderRadius: 15,
                          }}
                        >
                          <Button onClick={() => setBottom(false)}>
                            Close
                          </Button>
                        </span>
                      </Box>
                    </Box>
                    <OnlineStoresMobile product={product}/>
                    {/*product.onlineStores?.length > 0 ? (
                      <Box mt={3}>
                        {product.onlineStores.map((store, index) => (
                          <Card
                            key={index}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 2,
                              p: 2,
                              boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                              borderRadius: 5,
                            }}
                          >
                            <CardContent sx={{ flex: 1 }}>
                              <Box sx={{ maxWidth: "2vw" }}>
                                <Typography
                                  variant="h6"
                                  sx={{ color: "#205375", maxWidth: "10vw" }}
                                >
                                  {store.name}
                                </Typography>
                              </Box>
                              <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                {store.price}
                              </Typography>
                            </CardContent>
                            <Button
                              variant="contained"
                              color="primary"
                              href={store.url}
                              target="_blank"
                              sx={{ ml: 2, minWidth: "120px" }}
                            >
                              Buy Now
                            </Button>
                          </Card>
                        ))}
                      </Box>
                    ) : (
                      <Typography sx={{ mb: 2, mt: 4 }}>
                        {" "}
                        No online stores available for this product.
                      </Typography>
                    )*/}
                  </Box>
                  </Box>
                </SwipeableDrawer>

                {/* Additional Info */}
                <SwipeableDrawer
                  anchor={"bottom"}
                  open={additionalInfo}
                  onClose={() => setAdditionalInfo(false)}
                  onOpen={() => setAdditionalInfo(true)}
                >
                  <Box
                    sx={{
                      mt: 2,
                      maxHeight: "80vh",
                      minHeight: "15vh",
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 3,
                        position: "fixed",
                        width: "90%",
                        transform: "translateY(-2vh)",
                        // backgroundColor: "white",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h5"
                          color="#205375"
                          component="div"
                          sx={{ fontWeight: 600, textAlign: "left", mb: 2 }}
                        >
                          Additional{" "}
                          <span style={{ color: "#EF4F26" }}>Info</span>
                        </Typography>
                      </Box>
                      <Box sx={{ zIndex: 1 }}>
                        <span
                          style={{
                            border: "1px solid #205375",
                            padding: "5px 10px",
                            borderRadius: 15,
                          }}
                        >
                          <Button onClick={() => setAdditionalInfo(false)}>
                            Close
                          </Button>
                        </span>
                      </Box>
                    </Box>

                    {product?.data_from ? (
                      <Box mt={3}>
                        <Typography variant="body2" textAlign="left">
                          <b>Company:</b>
                          <span>
                            {product?.company ? (
                              <span>{" " + product.company}</span>
                            ) : (
                              "No company found"
                            )}
                          </span>
                        </Typography>

                        <Typography variant="body2" textAlign="left">
                          <b>Data from:</b>
                          <span>
                            {product?.data_from ? (
                              <span>{" " + product.data_from}</span>
                            ) : (
                              "Product data scource not found"
                            )}
                          </span>
                        </Typography>
                        <Typography variant="body2" textAlign="left">
                          <b>UPC:</b>
                          <span>
                            {product?.upc ? (
                              <span>{" " + product.upc}</span>
                            ) : (
                              "UPC not found"
                            )}
                          </span>
                        </Typography>
                      </Box>
                    ) : (
                      <Typography sx={{ mb: 2, mt: 4 }}>
                        {" "}
                        No additional information on this product.
                      </Typography>
                    )}
                  </Box>
                </SwipeableDrawer>

                {/* nearby stores */}
                <SwipeableDrawer
                  anchor="bottom"
                  open={nearbyStoresOpen}
                  onClose={() => setNearbyStoresOpen(false)}
                  onOpen={() => setNearbyStoresOpen(true)}
                >
                  <Box sx={{ mt: 2, maxHeight: "60vh", minHeight: "65vh", py: 2 }}>
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 3,
                        position: "fixed",
                        width: "100%",
                        transform: "translateY(-2vh)",
                      }}
                    >
                      <Box sx={{ px: 2 }}>
                        <Typography variant="h5" color="#205375" sx={{ fontWeight: 600, textAlign: "left", mb: 2 }}>
                          Nearby <span style={{ color: "#EF4F26" }}>Stores</span>
                        </Typography>
                      </Box>
                      <Box sx={{ zIndex: 1, px: 2 }}>
                        <span style={{ border: "1px solid #205375", padding: "5px 10px", borderRadius: 15 }}>
                          <Button onClick={() => setNearbyStoresOpen(false)}>Close</Button>
                        </span>
                      </Box>
                    </Box>

                    {/* ZIP Code Input (Only Show if Location is Denied) */}
                    {locationDenied && (
                      <Box sx={{ p: 3 }}>
                        <Typography variant="body1" color="error" sx={{ mb: 2 }}>
                          Location services are disabled or permission is denied. Please enter a ZIP code:
                        </Typography>
                        <TextField
                          label="Enter ZIP Code"
                          variant="outlined"
                          fullWidth
                          value={zipcode}
                          onChange={(e) => setZipcode(e.target.value)}
                          sx={{ mb: 2 }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          onClick={handleZipSubmit}
                          disabled={!zipcode.trim()}
                        >
                          Search
                        </Button>
                      </Box>
                    )}

                    {/* Pass ZIP Code to `NearbyStoresMobile` */}
                    {!locationDenied && (
                      <NearbyStoresMobile product={product} open={nearbyStoresOpen} zipcode={zipcode} />
                    )}
                  </Box>
                </SwipeableDrawer>

                {/* Bottom Button */}
                <Box
                    sx={{
                      p: 2,
                      "@media (max-width: 768px)": { width: "80%" },
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      maxWidth: { xs: "100%", sm: "50%", md: "50%", lg: "50%" },
                      borderRadius: 8,
                      backgroundColor: "#EF4F26",
                      cursor: "pointer",
                      textTransform: "none",
                      margin: "0 auto",
                      boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
                      position: "relative",
                      zIndex: 1,
                    }}
                    ref={bottomButtonRef}
                    onClick={() => setTalkToProductOpen(true)}
                  >
                    <Icon
                      icon="heroicons:chat-bubble-left-ellipsis"
                      fontSize="large"
                      style={{ color: "white", marginRight: 8 }}
                    />
                    <span style={{ color: "white", fontWeight: 500, fontSize: 16 }}>
                      Talk to the product!
                    </span>
                  </Box>

                  {/* Talk to Product Swipeable Drawer */}
                  <ChatMobile 
                    open={talkToProductOpen} 
                    onClose={() => setTalkToProductOpen(false)} 
                    id={id} 
                    product={product} 
                  />
              </Box>
            </Box>

            {/* Floating Chat Button */}
            <FloatingChatButton
              visible={!isBottomButtonVisible}
              onClick={() => navigate(`/products/chat/${id}`)}
            />
          </Box>
        )}
      </Container>
    </>
  );
};

export default Details;
